import { logger } from "@/utils/logger";
import { useMemo } from "react";
import useSWR from "swr";
import { fetchLatestInAppNotificationsForMember } from "./_actions/fetch-latest-in-app-notifications-for-member";
import { getLastCheckedForMember } from "./_actions/get-last-checked-for-member";
import { hasUnreadInAppNotificationsForMember } from "./_actions/has-unread-in-app-for-member";
import { updateLastCheckedForMember } from "./_actions/update-last-checked-for-member";

const refreshIntervalMs = 300000; // 5分間隔でポーリング

export function useInAppNotifications() {
  // 未読状態の管理
  const { data: unreadData, mutate: mutateUnread } = useSWR(
    "inAppNotifications-unread",
    hasUnreadInAppNotificationsForMember,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      refreshInterval: refreshIntervalMs,
    },
  );

  // 最新通知の管理
  const { data: notificationsData, isLoading } = useSWR(
    "inAppNotifications-latest",
    fetchLatestInAppNotificationsForMember,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      refreshInterval: refreshIntervalMs,
    },
  );

  // 最終確認時刻の管理
  const { data: lastCheckedData, mutate: mutateLastChecked } = useSWR(
    "inAppNotifications-lastChecked",
    getLastCheckedForMember,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      refreshInterval: refreshIntervalMs,
    },
  );

  const notifications = useMemo(
    () => (notificationsData?.success ? notificationsData.value : []),
    [notificationsData],
  );

  const lastCheckedAt = lastCheckedData?.success
    ? lastCheckedData.value.lastCheckedAt
    : null;

  const hasUnread = unreadData?.success ? unreadData.value.hasUnread : false;

  const markAsReadAndUpdateLastChecked = () => {
    // キャッシュを既読に更新
    mutateUnread(
      { success: true, value: { hasUnread: false } },
      { revalidate: false },
    );

    // 最終確認時刻を更新（キャッシュは更新しない）
    updateLastCheckedForMember().catch((error) => {
      logger.error({ error }, "Failed to update last checked");
    });
  };

  const refreshLastChecked = () => {
    // 最終確認時刻のキャッシュを再取得
    mutateLastChecked();
  };

  return {
    hasUnread,
    notifications,
    isLoading,
    lastCheckedAt,
    markAsReadAndUpdateLastChecked,
    refreshLastChecked,
  };
}
